import React from "react"
import Typography from "aldoo-ra/Typography"
import Input from "aldoo-ra/Input"

const TextPropertyEditor = ({
  property,
  value,
  onChange,
  propertyConfig,
  className = ""
}) => {

  if (!property || !propertyConfig) return null

  const handleChange = (e) => {
    onChange?.(property, e.target.value)
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <Typography
        variant="admin_body_small"
        className="font-medium capitalize text-admin_text_secondary text-sm"
      >
        {propertyConfig.label || property}
      </Typography>
      <Input
        variant="admin"
        value={value || ""}
        onChange={handleChange}
        placeholder={propertyConfig.placeholder || ""}
        debounce={300}
        readOnly={propertyConfig.readOnly || false}
        className={propertyConfig.readOnly ? "bg-admin_neutral_1" : ""}
      />
    </div>
  )
}

export default TextPropertyEditor